var LAST_CONTEXT_KEY = 'X-Tiz-Last-Retailer-Context';
var CONTEXT_KEY = 'X-Tiz-Retailer-Context';

var service = function($rootScope, $http, $state) {
  function setRetailer(id) {
    localStorage.setItem(LAST_CONTEXT_KEY, id);
    sessionStorage.setItem(CONTEXT_KEY, id);
    $rootScope.currentRetailerId = id;
  }

  var getCurrent = function() {
    return _.find($rootScope.retailers, { id: $rootScope.currentRetailerId });
  }

  var setSentryContext = function() {
    var retailer = getCurrent();
    window.sentryContext.retailer =
      _.pick(retailer, ['id', 'name', 'state']);
  };

  return {
    get: getCurrent,
    setSetup: function() {
      let r = _.find($rootScope.retailers, { id: $rootScope.currentRetailerId });
      r.completed_onboarding = true;
    },
    checkRes: function(res) {
      var id = res.headers('X-Tiz-Retailer-Context');
      if (id && Number(id) != $rootScope.currentRetailerId) {
        setRetailer(Number(id));
      }
      return res;
    },

    initialize: function(retailers) {
      $rootScope.retailers = retailers;
      var savedId = Number(sessionStorage.getItem(CONTEXT_KEY));
      if (!savedId) {
        savedId = Number(localStorage.getItem(LAST_CONTEXT_KEY));
      }
      if (!savedId) {
        savedId = Number(localStorage.getItem(CONTEXT_KEY));
        if (savedId) {
          sessionStorage.setItem(CONTEXT_KEY, savedId);
        }
      }

      $rootScope.currentRetailerId = savedId || null;
      $rootScope.getCurrentRetailer = function() {
        for(var i = 0; i < $rootScope.retailers.length; i++) {
          if($rootScope.retailers[i].id == $rootScope.currentRetailerId) return $rootScope.retailers[i];
        }
      };

      // Ensure that the current retailer id is valid
      if($rootScope.currentRetailerId && $rootScope.retailers.length) {
        var valid = false;

        for(var i = 0; i < $rootScope.retailers.length; i++) {
          if($rootScope.retailers[i].id == $rootScope.currentRetailerId) {
            valid = true;
            break;
          }
        }

        if(!valid) {
          setRetailer(null);
        }
      }

      // Set the current retailer ID if none exist
      if(!$rootScope.currentRetailerId && $rootScope.retailers.length) {
        setRetailer($rootScope.retailers[0].id);
      }

      setSentryContext();
    },
    getAllRetailers: function() {
      return $rootScope.retailers;
    },
    // Public API sets the retailer and then reloads the page
    setRetailer: function(id) {
      $rootScope.settingRetailer = true;
      setRetailer(id);
      if (_.includes(location.href, '/orders')) {
        window.location.assign('/orders');
      }
      else if (_.includes(location.href, '/lists')) {
        window.location.assign('/lists');
      }
      else {
        location.reload();
      }
    },
    setRetailerInner: function(id) {
      setRetailer(id);
      setSentryContext();
    }
  };
};

service.$inject = ['$rootScope', '$http', '$state'];

tiz.service('RetailerContext', service);

export default service;
